import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class ChangeRoutePositionArgs extends ActionArgs {
  @Field(() => ID)
  routeId: string

  @Field(() => String)
  input: string

  @Field(() => String, { nullable: true })
  filter?: string
}
